class Tab extends HTMLElement {
    constructor() {
      super();
      this.tab_header = this.querySelector(".tab_header");
      this.tab_content_wrapper = this.querySelector(".tab_content_wrapper");
    }
    connectedCallback() {
        window.addEventListener("shopify:section:load", (event) => {
          if (event.detail.sectionId == "{{ id }}") {
            initTabs();
          }
        });

        this.initTabs()
    }

    initTabs() {
        this.tab_header.addEventListener("click", (event) => {
          if (this.classList.contains("open")) {
            this.closeTab();
          } else {
            this.openTab();
          }
        });
    }
    openTab() {
        this.classList.remove("close");
        this.classList.add("open");
        let tab_content = this.tab_content_wrapper.querySelector(".tab_content");
        let height = tab_content.getBoundingClientRect().height;
        this.tab_content_wrapper.style.height = height + "px";
        setTimeout(() => {
        if (this.classList.contains("open")) {
            tab_content.style.position = "static";
            this.tab_content_wrapper.style.height = "auto";
        }
        }, 300);
    }
    closeTab() {
        this.classList.remove("open");
        this.classList.add("close");
        let tab_content = this.tab_content_wrapper.querySelector(".tab_content");
        let height = tab_content.getBoundingClientRect().height;
        this.tab_content_wrapper.style.height = height + "px";
        window.requestAnimationFrame(() => {
            tab_content.style = "";
            this.tab_content_wrapper.style = "";
        });
    }
  }
  customElements.define("custom-tab", Tab);
  